import { useMutation } from '@tanstack/react-query';

import type { DeleteEmployeeEmploymentContractArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: DeleteEmployeeEmploymentContractArgs) => {
  return employeeService.deleteEmployeeEmploymentContract(data);
};

export const useEmployeeDeleteContractMutation = () => {
  return useMutation<unknown, unknown, DeleteEmployeeEmploymentContractArgs>(mutationFn);
};
